import { IConfig } from '@qunhe/ktracker-types';
import defaultConfig from '../config.default';
import { IUserOptions } from '../types';
import { deepMerge, getInput } from './func';
import logger from './logger';

/**
 * Ktracker 全局配置
 */
export default class SystemOptions {
  private g_ktrackerCurrentLogCount: number = 0;
  private g_ktrackerOptions: IConfig | undefined;
  private g_ktrackerVisitId: string | undefined;

  private static instance: SystemOptions;

  private constructor() { }

  static getInstance() {
    if (!SystemOptions.instance) {
      SystemOptions.instance = new SystemOptions();
    }

    return SystemOptions.instance;
  }

  getCurrentLogCount() {
    if (this.g_ktrackerOptions && this.g_ktrackerOptions.debug) {
      logger.primary(`max error log count: ${this.g_ktrackerOptions.maxLogCount}; current error log count: ${this.g_ktrackerCurrentLogCount}`);
    }
    return this.g_ktrackerCurrentLogCount;
  }

  setCurrentLogCount(currentLogCount: number = 0) {
    this.g_ktrackerCurrentLogCount = currentLogCount;
  }

  increaseCurrentLogCount() {
    this.g_ktrackerCurrentLogCount++;
  }

  getOptions() {
    return this.g_ktrackerOptions!;
  }

  setOptions(options: IConfig) {
    this.g_ktrackerOptions = options;
  }

  clearOptions() {
    this.g_ktrackerOptions = undefined;
  }

  getVisitId() {
    return this.g_ktrackerVisitId!;
  }

  setVisitId(visitId: string) {
    this.g_ktrackerVisitId = visitId;
  }
}

/**
 * 合并用户自定义的配置
 * @param defaultOptions
 * @param pubConfig
 */
function getUserOptions(defaultOptions: IUserOptions, pubConfig: IUserOptions): IConfig {
  const result: any = { };
  for (const key of Object.keys(defaultOptions)) {
    let param;
    // 优先读取pub的配置
    if (pubConfig.hasOwnProperty(key)) {
      param = pubConfig[key];
    } else {
      param = getInput(key);
    }
    if (param !== undefined && param !== '') {
      switch (param) {
        case 'true':
        case true:
          result[key] = true;
          break;
        case 'false':
        case false:
          result[key] = false;
          break;
        default:
          const tmp = parseInt(param, 10);
          if (Number.isInteger(tmp)) {
            result[key] = tmp;
          } else {
            result[key] = param;
          }
          break;
      }
    } else {
      result[key] = defaultOptions[key];
    }
  }

  return result;
}

/**
 * 初始化全局配置
 * description:
 *  优先级 pub 配置 -> 用户配置 -> meta 头配置
 */
export function initOptions() {
  // window.g_ktrackerOptions pub 全局配置文件
  // window.ktrackerOptions 用户自定义全局配置文件
  const g_ktrackerOptions = window.g_ktrackerOptions || { };
  const ktrackerOptions = window.ktrackerOptions || { };
  const options = deepMerge(ktrackerOptions, g_ktrackerOptions);
  const userOpts = getUserOptions(defaultConfig, options);
  SystemOptions.getInstance().setOptions(userOpts);
  return userOpts;
}
